import { Divider, Flex, Form } from "antd";
import InscricaoProvedorPgtoFormBasic, { IInscricaoProvedorPgtoFormBasicProps } from "./InscricaoProvedorPgtoFormBasic";
import { IInscricaoAlterarProvedorParams, useInscricaoBuscarPorCodigo } from "@/Services/Domain/Viagem/InscricaoService";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";
type IInscricaoProvedorPgtoFormBasicPropsOp = Partial<Omit<IInscricaoProvedorPgtoFormBasicProps, "inscricao">> & { codInscricao : number; };
export interface IInscricaoProvedorPgtoFormProps extends IInscricaoProvedorPgtoFormBasicPropsOp {
    children?: () => React.ReactNode;
}
export default function InscricaoProvedorPgtoForm({ 
    form: formParam,
    children,
    codInscricao,
    ...rest 
}: IInscricaoProvedorPgtoFormProps) {
    const [newForm] = Form.useForm<IInscricaoAlterarProvedorParams>();
    const form = formParam ?? newForm;

    const {
        data,
        isFetching,
        isLoading
    } = useInscricaoBuscarPorCodigo({
        codInscricao: codInscricao
    });

    if (!(isFetching || isLoading) && data === undefined) return <>Inscrição não encontrada.</>;

    return <TelaCarregamento ativo={isFetching || isLoading}>
        <>
            <InscricaoProvedorPgtoFormBasic
                form={form}
                inscricao={data ?? {}}
                {...rest} 
            />
            {children && <>
                <Divider />
                <Flex gap="small" wrap="wrap" justify="center">
                    children
                </Flex>
            </>}
        </>
    </TelaCarregamento>;    
}